import { applyLayerStyling } from '@/map/layers/factory';
import { useLayerRegistry } from '@/map/layers/registry';
import { ensureFeatureLayer, requireLayerRecord } from './shared/layers';
import type { Tool } from './types';

type Input = { layer_id: string };

export const layerResetSymbology: Tool<Input> = {
  name: 'layer_reset_symbology',
  description:
    'Restore a feature layer to its renderer prior to `layer_classify`. No-op if the layer was never classified.',
  input_schema: {
    type: 'object',
    properties: {
      layer_id: { type: 'string' },
    },
    required: ['layer_id'],
    additionalProperties: false,
  },
  execute: async ({ layer_id }) => {
    const layer = await ensureFeatureLayer(layer_id);
    const record = requireLayerRecord(layer_id);

    if (!record.classified) {
      return { ok: true, layer_id, restored: false, reason: 'not classified' };
    }

    if (record.original_renderer) {
      layer.renderer = record.original_renderer;
    } else {
      // No snapshot to restore from — re-derive the default styling.
      applyLayerStyling(record, useLayerRegistry.getState().records);
    }

    useLayerRegistry.getState().patch(layer_id, {
      classified: undefined,
      original_renderer: undefined,
      legend: undefined,
    });

    return { ok: true, layer_id, restored: true };
  },
};
